module.exports = __webpack_public_path__ + "img/thumbnail_IndianElephant_j_albino.ce854ee8.png";